import { RequestStatus } from '@shared/model/request';
import { TagProps } from '@shared/ui/tag/types';

export const MANAGER_REQUEST_STATUS_MAP: Partial<Record<RequestStatus, TagProps>> = {
    new: {
        variant: 'blue',
        children: 'На рассмотрении',
    },
    order_forming: {
        variant: 'grey',
        children: 'Согласовано',
    },
    canceled: {
        variant: 'declined',
        children: 'Отклонено',
    },
    request_reject: {
        variant: 'declined',
        children: 'Отклонено',
    },
};
